<script setup>
/**
 * OCHAT: account logo and name at the foot of the sidebar.
 *
 * Renders nothing unless a logo thumbnail is configured, so a stock install is
 * unaffected.
 *
 * Worth knowing: LOGO_THUMBNAIL is an installation-level setting, not per
 * account, so every account on this instance sees the same image. The account
 * NAME below it is per account. If per-account logos are ever needed, the source
 * has to change, not just this template.
 */
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';

defineProps({
  isCollapsed: {
    type: Boolean,
    default: false,
  },
});

const globalConfig = useMapGetter('globalConfig/get');
const { currentAccount } = useAccount();
</script>

<template>
  <div
    v-if="globalConfig.logoThumbnail"
    class="flex gap-2 items-center px-3 py-2 border-t border-n-weak"
    :class="{ 'justify-center': isCollapsed }"
  >
    <img
      :src="globalConfig.logoThumbnail"
      class="flex-shrink-0 object-contain rounded-md size-7"
      alt=""
    />
    <span
      v-if="!isCollapsed"
      class="text-sm font-medium truncate text-n-slate-12"
    >
      {{ currentAccount?.name }}
    </span>
  </div>
</template>
